import * as React from "react";
import { UitkCardAlohaPlaceholder } from "uitk-react-cards";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { GridPlaceholderProps } from "./typings";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";

export const GridPlaceholder = (gridPlaceholderProps: GridPlaceholderProps) => {
  const keyHelper = new ItemKeyHelper(`${gridPlaceholderProps.flexTemplateNodeId}-placeholder-Grid`);

  return (
    <UitkSpacing margin={{ blockend: "three", blockstart: "four" }}>
      <div className="Deals">
        <UitkSpacing margin={{ inlinestart: "three" }}>
          <UitkCardAlohaPlaceholder className="placeholder-header" />
        </UitkSpacing>
        <UitkSpacing margin={{ inlinestart: "three", blockstart: "two" }}>
          <UitkCardAlohaPlaceholder className="placeholder-subheader" />
        </UitkSpacing>
        <UitkSpacing margin={{ inline: "three", blockstart: "three" }}>
          <UitkLayoutGrid columns={{ medium: 2, extra_large: 3, small: 1 }} space="three">
            {[...Array(12)].map((val, index) => (
              <div key={keyHelper.next()}>
                <UitkCardAlohaPlaceholder className="placeholder-card" />
              </div>
            ))}
          </UitkLayoutGrid>
        </UitkSpacing>
      </div>
    </UitkSpacing>
  );
};
